import {
  SET_SUCCESS_DIALOG_SHOW,
} from 'reducer/types/success_dialog'

export const setSuccessDialogShow = ({show}) => (dispatch) => {
  dispatch({
    type: SET_SUCCESS_DIALOG_SHOW,
    show
  })
}